// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Building2 } from 'lucide-react';
// import { toast } from 'react-toastify';
// import { useAuth } from '../../contexts/AuthContext';
// import PasswordInput from '../common/PasswordInput';

// const Login = () => {
//   const { login } = useAuth();
//   const navigate = useNavigate();
//   const [identifier, setIdentifier] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const handleLogin = async (e) => {
//     if (e) {
//       e.preventDefault();
//       e.stopPropagation();
//     }

//     setLoading(true);
//     setError('');
//     const id = (identifier || '').trim();
//     const pwd = (password || '').trim();

//     if (!id || !pwd) {
//       setError('Please enter email/phone and password');
//       setLoading(false);
//       return;
//     }

//     const credentials = id.includes('@') ? { email: id, password: pwd } : { phone: id, password: pwd };

//     try {
//       const result = await login(credentials);
//       if (result?.success) {
//         const loggedInUserType = result.user?.userType;
//         if (loggedInUserType === 'admin') navigate('/admin/dashboard', { replace: true });
//         else if (loggedInUserType === 'agent') navigate('/agent/dashboard', { replace: true });
//         else if (loggedInUserType === 'supervisor') navigate('/supervisor/dashboard', { replace: true });
//         else if (loggedInUserType === 'external_user') navigate('/external/collection-units', { replace: true });
//         else setError('Unknown user type');
//       } else {
//         setError(result?.error || 'Login failed');
//       }
//     } catch (err) {
//       const msg = err?.response?.data?.message ?? err?.response?.data?.error ?? 'Login failed. Please try again.';
//       setError(Array.isArray(msg) ? msg[0] : msg);
//       toast.error(Array.isArray(msg) ? msg[0] : msg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className='flex flex-1 min-h-0 w-full overflow-y-auto overscroll-y-contain flex-col items-center justify-center p-8 pb-28 relative z-10 animate-slide-up md:min-h-screen md:h-screen'>
//       <div className='text-center mb-12'>
//         <div className='w-24 h-24 bg-gradient-to-br from-[#FFC107] to-[#FF9800] rounded-3xl flex items-center justify-center mb-8 mx-auto'>
//           <Building2 className='w-12 h-12 text-white' />
//         </div>
//         <h1 className='text-4xl font-black italic mb-2 tracking-tighter text-white uppercase'>cssRMS</h1>
//         <p className='text-[#FFC107] text-sm font-bold uppercase tracking-[0.3em] mb-2'>Revenue Management System</p>
//         <p className='text-xs text-white/40'>Harvard RMetaverse Project</p>
//       </div>

//       <form onSubmit={handleLogin} className='w-full space-y-6' noValidate>
//         {error && <div className='p-3 bg-red-500/20 border border-red-500/50 rounded-xl text-red-300 text-sm text-center'>{error}</div>}

//         <div>
//           <label className='block text-xs font-bold uppercase text-white/60 mb-2'>Email or Phone</label>
//           <input
//             type='text'
//             autoComplete='username'
//             value={identifier}
//             onChange={(e) => setIdentifier(e.target.value)}
//             placeholder='email@example.com or +233XXXXXXXXX'
//             className='w-full p-4 bg-white/5 border border-white/10 rounded-2xl outline-none text-white placeholder-white/30 text-sm select-text relative z-10'
//           />
//           <p className='text-xs text-white/40 mt-1'>Use email or phone (with country code for SMS accounts).</p>
//         </div>

//         <div>
//           <label className='block text-xs font-bold uppercase text-white/60 mb-2'>Password</label>
//           <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Enter your password' required />
//         </div>

//         <button type='submit' disabled={loading || !identifier.trim() || !password.trim()} className='w-full py-4 rounded-2xl btn-gold font-black uppercase text-sm disabled:opacity-50'>
//           {loading ? 'Logging in...' : 'Login'}
//         </button>

//         <button type='button' onClick={() => navigate('/setup-password')} className='w-full text-xs text-white/60 hover:text-white/90 underline'>
//           First time user? Setup password with OTP
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Mail, Phone } from 'lucide-react';
import { toast } from 'react-toastify';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useAuth } from '../../contexts/AuthContext';
import PasswordInput from '../common/PasswordInput';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [tab, setTab] = useState('email');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }

    setLoading(true);
    setError('');

    const pwd = password.trim();
    const id = tab === 'email' ? email.trim() : phone;

    if (!id || !pwd) {
      setError('Please enter your login details and password');
      setLoading(false);
      return;
    }

    if (tab === 'phone' && !isValidPhoneNumber(phone || '')) {
      setError('Please enter a valid phone number');
      setLoading(false);
      return;
    }

    const credentials = tab === 'email'
      ? { email: id, password: pwd }
      : { phone: id, password: pwd };

    try {
      const result = await login(credentials);
      if (result?.success) {
        const t = result.user?.userType;
        if (t === 'admin')              navigate('/admin/dashboard',             { replace: true });
        else if (t === 'agent')         navigate('/agent/dashboard',             { replace: true });
        else if (t === 'supervisor')    navigate('/supervisor/dashboard',        { replace: true });
        else if (t === 'external_user') navigate('/external/collection-units',   { replace: true });
        else setError('Unknown user type');
      } else {
        setError(result?.error || 'Login failed');
      }
    } catch (err) {
      const msg = err?.response?.data?.message ?? err?.response?.data?.error ?? 'Login failed. Please try again.';
      setError(Array.isArray(msg) ? msg[0] : msg);
      toast.error(Array.isArray(msg) ? msg[0] : msg);
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = loading || !password.trim() || (tab === 'email' ? !email.trim() : !phone);

  return (
    <div className='flex flex-1 min-h-0 w-full overflow-y-auto overscroll-y-contain flex-col items-center justify-center p-8 pb-28 relative z-10 animate-slide-up md:min-h-screen md:h-screen'>
      <div className='text-center mb-12'>
        <div className='w-24 h-24 bg-gradient-to-br from-[#FFC107] to-[#FF9800] rounded-3xl flex items-center justify-center mb-8 mx-auto'>
          <Building2 className='w-12 h-12 text-white' />
        </div>
        <h1 className='text-4xl font-black italic mb-2 tracking-tighter text-white uppercase'>cssRMS</h1>
        <p className='text-[#FFC107] text-sm font-bold uppercase tracking-[0.3em] mb-2'>Revenue Management System</p>
        <p className='text-xs text-white/40'>Harvard RMetaverse Project</p>
      </div>

      <form onSubmit={handleLogin} className='w-full space-y-6' noValidate>
        {error && (
          <div className='p-3 bg-red-500/20 border border-red-500/50 rounded-xl text-red-300 text-sm text-center'>
            {error}
          </div>
        )}

        {/* Tab switcher */}
        <div className='flex bg-white/5 border border-white/10 rounded-2xl p-1 gap-1'>
          <button
            type='button'
            onClick={() => { setTab('email'); setError(''); }}
            className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-xs font-bold uppercase tracking-wider transition-all duration-200 ${
              tab === 'email'
                ? 'bg-gradient-to-r from-[#FFC107] to-[#FF9800] text-black'
                : 'text-white/40 hover:text-white/70'
            }`}
          >
            <Mail className='w-3.5 h-3.5' /> Email
          </button>
          <button
            type='button'
            onClick={() => { setTab('phone'); setError(''); }}
            className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-xl text-xs font-bold uppercase tracking-wider transition-all duration-200 ${
              tab === 'phone'
                ? 'bg-gradient-to-r from-[#FFC107] to-[#FF9800] text-black'
                : 'text-white/40 hover:text-white/70'
            }`}
          >
            <Phone className='w-3.5 h-3.5' /> Phone
          </button>
        </div>

        {/* Email field */}
        {tab === 'email' && (
          <div>
            <label className='block text-xs font-bold uppercase text-white/60 mb-2'>Email Address</label>
            <input
              type='email'
              autoComplete='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder='email@example.com'
              className='w-full p-4 bg-white/5 border border-white/10 rounded-2xl outline-none text-white placeholder-white/30 text-sm'
            />
          </div>
        )}

        {/* Phone field */}
        {tab === 'phone' && (
          <div>
            <label className='block text-xs font-bold uppercase text-white/60 mb-2'>Phone Number</label>
            <PhoneInput
              international
              defaultCountry='GH'
              value={phone}
              onChange={setPhone}
              placeholder='XX XXX XXXX'
              className='phone-input-dark'
            />
            <p className='text-xs text-white/40 mt-1'>Ghana (+233) selected by default</p>
          </div>
        )}

        {/* Password */}
        <div>
          <label className='block text-xs font-bold uppercase text-white/60 mb-2'>Password</label>
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder='Enter your password'
            required
          />
        </div>

        <button
          type='submit'
          disabled={isDisabled}
          className='w-full py-4 rounded-2xl btn-gold font-black uppercase text-sm disabled:opacity-50'
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>

        <button
          type='button'
          onClick={() => navigate('/forgot-password')}
          className='w-full text-xs text-white/60 hover:text-white/90 underline'
        >
          Forgot password?
        </button>

        <button
          type='button'
          onClick={() => navigate('/setup-password')}
          className='w-full text-xs text-white/60 hover:text-white/90 underline'
        >
          First time user? Setup password with OTP
        </button>
      </form>
    </div>
  );
};

export default Login;